module.exports = __webpack_public_path__ + "media/info-item-1.a9a702a0.mp4";